var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5111 57.9C71.6111 54 66.9111 51.1 61.9111 49.3C67.3111 45.6 70.9111 39.3 70.9111 32.2C70.9111 21.3 62.2111 12.1 51.3111 11.5C39.3111 10.8 29.4111 20.4 29.4111 32.2C29.4111 39.3 33.0111 45.5 38.4111 49.3C33.3111 51.1 28.7111 53.9 24.8111 57.9C18.7111 64 15.1111 71.8 14.4111 80.3C14.3111 81.9 15.6111 83.3 17.2111 83.3C18.7111 83.3 19.9111 82.2 20.0111 80.7C21.3111 65.2 34.3111 53 50.1111 53C65.9111 53 78.9111 65.2 80.3111 80.7C80.4111 82.2 81.6111 83.3 83.1111 83.3C84.7111 83.3 86.0111 81.9 85.9111 80.3C85.2111 71.8 81.5111 64 75.5111 57.9ZM52.1111 47.3C42.2111 48.6 33.9111 40.2 35.1111 30.3C36.0111 23.6 41.4111 18.1 48.1111 17.3C58.0111 16 66.3111 24.4 65.1111 34.3C64.3111 41 58.8111 46.4 52.1111 47.3Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilo);
export default __webpack_public_path__ + "static/media/profilo.9cdb2cc634b67669ec7a91a491fba894.svg";
export { ForwardRef as ReactComponent };